import { render } from "./CommentItems.vue?vue&type=template&id=e3f8edec&scoped=true"
import script from "./CommentItems.vue?vue&type=script&lang=js"
export * from "./CommentItems.vue?vue&type=script&lang=js"

import "./CommentItems.vue?vue&type=style&index=0&id=e3f8edec&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3f8edec"]])

export default __exports__